var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Loader } from './loader';
var cls = classNames('grid-loader');
export var GridLoaderDefaultProps = {
  spinnerSize: 24
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  "], ["\n    padding: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  "])), theme.UNIT(8))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Loader: styled(Loader)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles)
};
/* @ts-ignore */
export var GridLoader = React.forwardRef(function (props, ref) {
  var className = props.className,
    message = props.message,
    spinnerSize = props.spinnerSize;
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, React.createElement(My.Loader, {
    spinnerSize: spinnerSize,
    message: message
  }));
});
GridLoader.cls = cls;
GridLoader.defaultProps = GridLoaderDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;